export const defaultFCValue = 0
